import { RootState } from '@/domain/store';

export const selectIsOrganisationSet = (state: RootState) => {
  return state.organisation.isOrganisationSet;
};

export const selectIsCreatingOrganisation = (state: RootState) => {
  return state.organisation.isCreatingOrganisation;
};

export const selectIsEditingOrganisation = (state: RootState) => {
  return state.organisation.isEditingOrganisation;
};

export const selectOrganisationInfos = (state: RootState) => {
  return state.organisation.organisationInfos;
};
